import React, { useState, useEffect, ChangeEvent, useRef } from "react"
import {
    Button,
    CardBody,
    IconButton,
    Input,
    Spinner,
    Typography,
} from "@material-tailwind/react"

import { CustomHeader } from "../../../components/headers/CustomHeader"
import { useHistory } from "react-router-dom"
import { PolicyDetails, Document } from "./policy_detaildummy"
import { BiEdit, BiPlus, BiTrash } from "react-icons/bi"
import { UserType } from "../../../types/user"
import { DEFAULTPRIMARYCOLOR } from "../../../util"
import { useQuery } from "@apollo/client"
import { QUOTATIONDETAILS } from "../../../GraphQl/queries"
import { BASEURL } from "../../../util"
import { toast } from "react-toastify"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import { DriverModal } from "../../../components/modal/DriverModal"
import ErrorLog from "../../../components/error-logs"
import { useMutation } from "@apollo/client"
import { UPDATEDOCUMENT } from "../../../GraphQl/mutations"

import SelectInput from "../../../components/select/SelectInput"
import { GET_ALL_SETUPS, GETALLRISKCLASS, GETALLCOLORS } from "../../../GraphQl/queries"

const QuotationEdit = () => {
    const [RequestLoading, setRequestLoading] = useState(false)
    const [formData, setFormData] = useState<any | null>(null)
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [errors, setErrors] = useState<any | null>(null)



    const parseVehicleDetails = (vehicle_details_name: string) => {
        return vehicle_details_name.split(", ").reduce((acc, item) => {
            const [key, value] = item.split(": ");
            acc[key.trim()] = value ? value.trim() : ""; // Handle empty values
            return acc;
        }, {} as Record<string, string>);
    };


    const vehicleDetails = formData?.request[0]?.vehicle_details_name
        ? parseVehicleDetails(formData?.request[0]?.vehicle_details_name)
        : {};






    const handleSubmit = async () => {
        if (!formData || !formData.request || formData.request.length === 0) {
            toast.error("Request data is missing!");
            return;
        }

        const requestData = formData.request[0];

        const formPayload = {
            start_date: requestData?.start_date,
            quote_id: requestData?.id,
            customer_id: requestData?.customer?.id,
            type_of_cover: requestData?.cover_type,
            duration: requestData?.duration,
            premium_amount: requestData?.amount,
            currency: requestData?.currencyByCurrency?.id,
            risk_class_id: requestData?.risk_class?.id,
            end_date: requestData?.end_date,
            vehicle_metadata: {
                number_of_seats: requestData?.vehicle_details?.number_of_seats,
                vehicle_value: requestData?.vehicle_details?.vehicle_value,
                accessories_value: requestData?.vehicle_details?.accessories_value,
                registration_number: requestData?.vehicle_details?.registration_number,
                year_of_manufacture: requestData?.vehicle_details?.year_of_manufacture,
                body_type: requestData?.vehicle_details?.body_type,
                make_of_vehicle: requestData?.vehicle_details?.make_of_vehicle,
                vehicle_model: requestData?.vehicle_details?.vehicle_model,
                color: requestData?.vehicle_details?.color,
                chassis_number: requestData?.vehicle_details?.chassis_number,
            },
            customer_details_metadata: {
                first_name: requestData?.customer?.first_name,
                last_name: requestData?.customer?.last_name,
                phone_number: requestData?.customer?.phone_number,
                email: requestData?.customer?.email,
                customer_type: requestData?.customer?.customer_type || "individual",
                ghana_card: requestData?.customer?.ghana_card,
                address: requestData?.customer?.address || "",
                gender: requestData?.customer?.gender || "Male",
                dob: requestData?.customer?.dob || "",
            },
            user_type: "company_administrator",
            car_number_type: requestData?.car_number_type || "standard",
        };


        try {
            setLoading(true);
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/update-quotation`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(formPayload),
            });

            const result = await response.json();


            if (response.ok) {
                toast.success(result?.message ?? "Quotation successfully updated");
            } else {
                toast.error(result?.detail ?? result?.data ?? "Failed to update quotation");
            }

            setLoading(false);
        } catch (err) {
            console.error("Error submitting data:", err);
            toast.error("Error submitting data, please try again!");
            setLoading(false);
        }
    };



    

    


    const {
        companyId,
        roleId,
        usertype,
        user: stateUser,
        token,
    } = useSelector((state: RootState) => state.auth)

    const { data, loading: loadingPolicies } = useQuery<{
        policy: PolicyDetails[]
        documents: Document[]
        request: Request[]
    }>(QUOTATIONDETAILS, {
        variables: {
            id: localStorage.getItem("selected-editquote-id"),
        },
    })
    console.log(data)

    useEffect(() => {
        if (data) {


            setFormData((prevData: any) => ({
                ...prevData, 

                ...(data?.policy.length > 0
                    ? { policy_sticker_creation_metadata: data.policy[0].policy_sticker_creation_metadata }
                    : {}),

                ...(data?.request.length > 0 ? { request: data.request } : {}),
            }));

            // Extract and set error logs if documents exist
            if (data?.documents.length > 0) {
                const { error_logs } = data.documents[0];
                setErrors(error_logs);
            }
        }
    }, [data]);




    const userData = localStorage.getItem("user")
    const [colors, setColors] = useState<string[]>()

    useEffect(() => {
        if (userData) {
            const data: UserType = JSON.parse(userData)

            setColors(data.colors)
        }
    }, [])

    const handleChange = (
        e: ChangeEvent<HTMLInputElement>,
        section: "customer" | "vehicle_details"  | null = null
    ) => {
        const { name, value } = e.target



        setFormData((prevData: any) => {
            const newData = { ...prevData }
            const motorPolicy =
                newData?.request[0]

            if (section) {
                motorPolicy![section] = {
                    ...motorPolicy[section],
                    [name]: value,
                }
            } else {
                motorPolicy[name] = value
            }

            return newData
        })
    }



    const handleSelectChange = (
        value: string,
        name: string,
        section: "customer" | "vehicle_details" | "risk_class" | null = null
    ) => {

        setFormData((prevData: any) => {
            const newData = { ...prevData }

            const motorPolicy =
                newData?.request[0]

            if (section) {
                motorPolicy[section] = {
                    ...motorPolicy[section],
                    [name]: value,
                };
            } else {
                motorPolicy[name] = value;
            }
            return newData
        })
    }



    interface VehicleModel {
        label: string;
        value: number;
    }

    interface VehicleMake {
        label: string;
        value: number;
        vehicleModels: VehicleModel[];
    }

    interface BodyType {
        label: string;
        value: number;
    }

    interface UseSelectOptionsReturn {
        vehicleMakes: VehicleMake[];
        bodyTypes: BodyType[];
        error?: string;
    }

    const useSelectOptions = (): UseSelectOptionsReturn => {
        const { data, loading, error } = useQuery(GET_ALL_SETUPS);

        if (loading) return { vehicleMakes: [], bodyTypes: [] };
        if (error) return { error: error.message, vehicleMakes: [], bodyTypes: [] };

        const vehicleMakes: VehicleMake[] = data?.vehicle_makes.map((make: any) => ({
            label: make.name,
            value: make.id,
            vehicleModels: make.vehicle_models.map((model: any) => ({
                label: model.name,
                value: model.id
            }))
        })) || [];

        const bodyTypes: BodyType[] = data?.body_types.map((bodyType: any) => ({
            label: bodyType.name,
            value: bodyType.id
        })) || [];

        return { vehicleMakes, bodyTypes };
    };

    const { vehicleMakes, bodyTypes } = useSelectOptions()


    const [selectedModel, setSelectedModel] = useState<string>('');
    const [selectedMake, setSelectedMake] = useState<string>('');
    const [selectedBodyType, setSelectedBodyType] = useState(vehicleDetails.BodyType);
    const [modelOptions, setModelOptions] = useState<VehicleModel[]>([]);

    const handleModelChange = (value: string) => {
        setSelectedModel(value);
    };



    const bodyTypeOptions = bodyTypes.map(body => ({
        value: body.value.toString(),
        text: body.label,
    }));

    const numberTyes = [
        {
            value: 'standard',
            text: 'standard'
        },

        {
            value: 'customised',
            text: 'customised'
        },
    ]


    

    // Handle make change
    const handleMakeChange = (newSelectedMake: string) => {
        setSelectedMake(newSelectedMake);

        const make = vehicleMakes.find(m => m.value.toString() === newSelectedMake);
        if (make) {
            setModelOptions(make.vehicleModels);
            setSelectedModel(''); // Reset model if make changes
        } else {
            setModelOptions([]);
        }
    };

    // Get Risk Classes
    interface RiskOptions {
        label: string;
        value: string;
    }

    interface UseRiskClassOptionsReturn {
        riskClassOptions: RiskOptions[];
        error?: string;
    }

    const useRiskClassOptions = (): UseRiskClassOptionsReturn => {
        const { data, loading, error } = useQuery(GETALLRISKCLASS);

        if (loading || !data) return { riskClassOptions: [] };
        if (error) return { error: error.message, riskClassOptions: [] };

        const riskClassOptions: RiskOptions[] = data.risk_class?.map((risk: any) => ({
            label: risk.name,
            value: risk.id?.toString() ?? "",
        })) || [];

        return { riskClassOptions };
    };

    const { riskClassOptions, error: riskClassError } = useRiskClassOptions();

    // Get Colors
    interface ColorOptions {
        label: string;
        value: string;
    }

    interface UseColorClassOptionsReturn {
        colorClassOptions: ColorOptions[];
        error?: string;
    }

    const useColorClassOptions = (): UseColorClassOptionsReturn => {
        const { data, loading, error } = useQuery(GETALLCOLORS);

        if (loading || !data) return { colorClassOptions: [] };
        if (error) return { error: error.message, colorClassOptions: [] };

        const colorClassOptions: ColorOptions[] = data.colors?.map((color: any) => ({
            label: color.name,
            value: color.id?.toString() ?? "",
        })) || [];

        return { colorClassOptions };
    };

    const { colorClassOptions, error: colorClassError } = useColorClassOptions();

    return (
        <>
            <div className="flex w-full justify-between items-center">
                <CustomHeader title="Edit quotation information" />

            </div>
            <div className="w-full flex flex-col md:flex-row lg:flex-row gap-5">
                <div className=" rounded-lg overflow-y-scroll w-full  lg:w-3/4">
                    <div className="w-full flex flex-col space-y-4">
                        <div className="p-3 bg-white rounded-b-xl ">
                            <Typography className="text-lg font-bold">
                                Customer Information{" "}
                            </Typography>
                            <div className="grid grid-cols-2 gap-4 mt-4">
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    type="text"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"

                                    name="first_name"
                                    label="First Name"
                                    defaultValue={
                                        formData?.request[0]?.customer?.first_name
                                    }
                                    onChange={(e) => handleChange(e, "customer")}
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Last Name"
                                    name="last_name"
                                    defaultValue={
                                        formData?.request[0]?.customer?.last_name
                                    }
                                    onChange={(e) => handleChange(e, "customer")}
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Other Name"
                                    name="other_names"
                                    defaultValue={
                                        formData?.request[0]?.customer?.other_names
                                    }
                                    onChange={(e) => handleChange(e, "customer")}
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Email"
                                    defaultValue={
                                        formData?.request[0]?.customer?.email
                                    }
                                    onChange={(e) => handleChange(e, "customer")}
                                    name="email"
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Phone Number"
                                    defaultValue={
                                        formData?.request[0]?.customer?.phone_number
                                    }
                                    onChange={(e) => handleChange(e, "customer")}
                                    name="phone_number"
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Digital address"
                                    defaultValue={
                                        formData?.request[0]?.customer?.digitalAddress
                                    }
                                    onChange={(e) => handleChange(e, "customer")}
                                    name="digitalAddress"
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Postal Address"
                                    defaultValue={
                                        formData?.request[0]?.customer?.address
                                    }
                                    onChange={(e) => handleChange(e, "customer")}
                                    name="address"
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Residential address"
                                    defaultValue={
                                        formData?.request[0]?.customer?.residential_address
                                    }
                                    onChange={(e) => handleChange(e, "customer")}
                                    name="residential_address"
                                />
                                <SelectInput
                                    label="Gender"
                                    options={[
                                        { text: "Male", value: "Male" },
                                        { text: "Female", value: "Female" }
                                    ]}
                                    defaultValue={formData?.request[0]?.customer?.gender}
                                    onChange={(val) => handleSelectChange(val, "gender", "vehicle_details")}
                                    name="gender"
                                />
                                
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="National ID"
                                    defaultValue={
                                        formData?.request[0]?.customer?.ghana_card
                                    }
                                    onChange={(e) => handleChange(e, "customer")}
                                    name="ghana_card"
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Dob"
                                    defaultValue={
                                        formData?.request[0]?.customer?.dob
                                    }
                                    onChange={(e) => handleChange(e, "customer")}
                                    name="dob"
                                />
                            </div>
                        </div>

                        <div className="p-3 bg-white rounded-xl">
                            <Typography className="text-lg font-bold">
                                Vehicle Information{" "}
                            </Typography>

                            <div className="grid grid-cols-2 gap-4 mt-4">
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    name="registration_number"
                                    label="Vehicle Registration Number"
                                    defaultValue={formData?.request[0]?.vehicle_details?.registration_number}
                                    onChange={(e) => handleChange(e, "vehicle_details")}
                                />
                                {/* <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Color"
                                    name="color"
                                    defaultValue={formData?.request[0]?.vehicle_details?.color}
                                    onChange={(e) => handleChange(e)}
                                /> */}
                                <SelectInput
                                    label="Color"
                                    defaultValue={formData?.request[0]?.vehicle_details?.color}
                                    options={colorClassOptions.map(color => ({
                                        value: color.label, // Backend ID
                                        text: color.label              // Display name})
                                        })
                                    )} 
                                    onChange={(val) => {
                                        console.log("val", val)
                                        handleSelectChange(val,"color","vehicle_details"); handleMakeChange(val);
                                    }}
                                    name="color"
                                />
                                {/*
                                 <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Vehicle Make"
                                    name="vehicle_make"
                                    defaultValue={vehicleDetails["Mke"]}
                                    onChange={(e) => handleChange(e)}
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Vehicle Model"
                                    name="vehicle_model"
                                    defaultValue={vehicleDetails["Model"]}
                                    onChange={(e) => handleChange(e)}
                                /> */}
                                <SelectInput
                                    label="Vehicle Make"
                                    defaultValue={vehicleDetails["Make"]}
                                    options={vehicleMakes.map(make => ({
                                        value: make.value.toString(), // Backend ID
                                        text: make.label              // Display name
                                    }))}
                                    onChange={(val) => {
                                        handleSelectChange(val,"make_of_vehicle","vehicle_details"); handleMakeChange(val);
                                    }}
                                    name="make_of_vehicle"
                                />
                                <SelectInput
                                    options={modelOptions.map(model => ({
                                        value: model.value.toString(),
                                        text: model.label,
                                    }))}
                                    label="Vehicle Model"
                                    defaultValue={vehicleDetails["Model"]}
                                    onChange={(val,) => {
                                        setSelectedModel(val);
                                        handleSelectChange(val, "vehicle_model", "vehicle_details");
                                    }}
                                    name="vehicle_model"
                                />
                                <SelectInput
                                    label="Body Type"
                                    options={bodyTypeOptions}
                                    defaultValue={vehicleDetails["Body Type"]}
                                    onChange={(val) => {
                                        setSelectedBodyType(val);
                                        handleSelectChange(val, "body_type", "vehicle_details");
                                    }}
                                    name="body_type"
                                />
                                {/* <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Body Type"
                                    name="body_type"
                                    defaultValue={vehicleDetails["Body Type"]}
                                    onChange={(e) => handleChange(e)}
                                /> */}
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Manufacture Year"
                                    name="year_of_manufacture"
                                    defaultValue={formData?.request[0]?.vehicle_details?.year_of_manufacture}
                                    onChange={(e) => handleChange(e, "vehicle_details")}
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Chassis Number"
                                    name="chassis_number"
                                    defaultValue={formData?.request[0]?.vehicle_details?.chassis_number}
                                    onChange={(e) => handleChange(e, "vehicle_details")}
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Number of Seats"
                                    name="number_of_seats"
                                    defaultValue={formData?.request[0]?.vehicle_details?.number_of_seats}
                                    onChange={(e) => handleChange(e, "vehicle_details")}
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Value of Car"
                                    name="vehicle_value"
                                    defaultValue={formData?.request[0]?.vehicle_details?.vehicle_value}
                                    onChange={(e) => handleChange(e, "vehicle_details")}
                                />
                                <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Accessories value"
                                    name="mileage"
                                    defaultValue={formData?.request[0]?.vehicle_details?.accessories_value}
                                    onChange={(e) => handleChange(e, "vehicle_details")}
                                />

                                <SelectInput
                                    label="Car Number Type"
                                    options={numberTyes}
                                    defaultValue={formData?.request[0]?.car_number_type}
                                    onChange={(val) => {
                                        handleSelectChange(val, "car_number_type", null);
                                    }}
                                    name="car_number_type"
                                />

                            </div>

                        </div>
                    </div>
                </div>

                <div className="flex flex-col space-y-4 w-full rounded-lg lg:col-span-2 overflow-hidden">

                    <div className="w-full">
                        <div className="p-3 bg-white rounded-b-xl">
                            <Typography className="text-lg font-bold">
                                Quotation Information{" "}
                            </Typography>
                            <div className="grid grid-cols-3 gap-4 mt-4">
                                {/* <Input label="Fleet Discount" name="fleet_discount" defaultValue={formData?.request[0]?.amended_rated_details?.fleet_discount} onChange={handleChange} />
                                <Input label="Other Discount" name="other_discount" defaultValue={formData?.request[0]?.amended_rated_details?.other_discount} onChange={handleChange} />
                                <Input label="Own Damage Rate" name="own_damage_rate" defaultValue={formData?.request[0]?.amended_rated_details?.own_damage_rate} onChange={handleChange} />
                                <Input label="No Claim Discount" name="no_claim_discount" defaultValue={formData?.request[0]?.amended_rated_details?.no_claim_discount} onChange={handleChange} /> */}
                                <Input label="Amount" name="amount" defaultValue={formData?.request[0]?.amount} onChange={handleChange} />
                                {/* <Input label="Extra PA" name="extra_pa" defaultValue={formData?.request[0]?.benefit_added_details?.extra_pa} onChange={handleChange} />
                                <Input label="Extra TPPDL" name="extra_tppdl" defaultValue={formData?.request[0]?.benefit_added_details?.extra_tppdl} onChange={handleChange} />
                                <Input label="Loss of Use" name="loss_of_use" defaultValue={formData?.request[0]?.benefit_added_details?.loss_of_use} onChange={handleChange} />

                                <Input label="Umbrella TPPDL Limit" name="umbrella_tppdl_limit" defaultValue={formData?.request[0]?.benefit_added_details?.umbrella_tppdl_limit} onChange={handleChange} /> */}
                                <Input label="Business Class" name="business_class" defaultValue={formData?.request[0]?.businessClassByBusinessClass?.name} onChange={handleChange} />
                                <Input label="Car Number Type" disabled name="car_number_type" defaultValue={formData?.request[0]?.car_number_type} onChange={handleChange} />
                                <Input label="Cover Type" name="cover_type" defaultValue={formData?.request[0]?.cover_type} onChange={handleChange} />
                                <Input label="Currency" name="currency" defaultValue={formData?.request[0]?.currencyByCurrency?.name} onChange={handleChange} />
                                <Input label="Duration (months)" name="duration" defaultValue={formData?.request[0]?.duration} onChange={handleChange} />
                                <Input label="End Date (yyyy-mm-dd)" name="end_date" defaultValue={formData?.request[0]?.end_date} onChange={handleChange} />
                                <Input label="Start Date (yyyy-mm-dd)" name="start_date" defaultValue={formData?.request[0]?.start_date} onChange={handleChange} />
                                <Input label="Payment Channel" name="payment_channel" defaultValue={formData?.request[0]?.payment_channel} onChange={handleChange} />
                                <Input label="Registration Number" disabled name="registration_number" defaultValue={formData?.request[0]?.registration_number_text} onChange={handleChange} />
                                <Input label="Request ID" name="request_id" defaultValue={formData?.request[0]?.request_id} onChange={handleChange} />
                                {/* <Input label="Risk Class" name="risk_class" defaultValue={formData?.request[0]?.risk_class?.name} onChange={handleChange} /> */}
                                <SelectInput
                                    label="Risk Class"
                                    options={riskClassOptions.map(model => ({
                                        value: model.value.toString(),
                                        text: model.label,
                                    }))}
                                    defaultValue={formData?.request[0]?.risk_class?.name}
                                    onChange={(val) => handleSelectChange(val, "id", "risk_class")}
                                    name="risk_class"
                                />
                                <Input label="Status" disabled name="status" defaultValue={formData?.request[0]?.status} onChange={handleChange} />
                                <Input label="User Type"  disabled  name="user_type" defaultValue={formData?.request[0]?.user_type} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="mt-5 mb-4 flex gap-4 items-end justify-end">
                            <Button
                                type="button"
                                onClick={(e) => {
                                    // e.preventDefault(); 

                                    handleSubmit();

                                }}
                                size="sm"
                                className="capitalize flex items-center flex-row items-centerfont-normal"
                                style={{
                                    background:
                                        colors?.length! > 1
                                            ? `${colors![0]?.toLowerCase()}`
                                            : `${DEFAULTPRIMARYCOLOR}`,
                                }}
                            >
                                <BiPlus size={20} />
                                {loading ? <Spinner className="w-4 h-4" /> : "Save"}
                            </Button>


                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default QuotationEdit
